// extracted by css-extract-rspack-plugin
export default {"Box":"alert-dialog-module__Box__iHQKn","Box_1":"alert-dialog-module__Box_1__n_P2I"};